export function overflowCheck(props) {
  if (typeof document === "undefined") return;
  document.body.style.overflow = props ? "hidden" : "auto";
}

// Array is empty
export function isEmptyArray(arr) {
  return Array?.isArray(arr) && arr?.length === 0;
}

// Array is not empty
export function isNotEmptyArray(arr) {
  return Array?.isArray(arr) && arr?.length > 0;
}

// check url
export const isValidUrl = (url) => {
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch (err) {
    return false;
  }
};

export const isRouteActive = (item, pathname, language) => {
  const normalizedPathname = pathname.startsWith(`/${language}`)
    ? pathname.replace(`/${language}`, "") || "/"
    : pathname;

  if (item.dropdown && item.dropdown.length > 0) {
    return item.dropdown.some((dropdownItem) => {
      const normalizedDropdownPath = dropdownItem.path.startsWith("/")
        ? dropdownItem.path
        : `/${dropdownItem.path}`;
      return normalizedPathname === normalizedDropdownPath;
    });
  }

  const normalizedItemPath = item.path.startsWith("/") ? item.path : `/${item.path}`;
  return normalizedPathname === normalizedItemPath;
};